export default __webpack_public_path__ + "409abb9ef3af7c9bb28832d2bb02304c.png";